import type { Noyau } from '@mss_creator/shared';

/** The fictitious company every miniature draws: "Maison Orée", noyau Vert (PSG). */
export const FAKE_COMPANY: { readonly name: string; readonly noyau: Noyau } = {
  name: 'Maison Orée',
  noyau: 'PSG',
};

/** Names of its six activation leviers, in order. */
export const FAKE_LEVIER_NAMES: readonly string[] = [
  "Rituel d'accueil",
  'Écoute active',
  'Preuve sociale',
  'Engagement',
  'Surprise',
  'Fidélité',
];

/** Orders (1-6) of its six leviers / setup steps. */
export const FAKE_LEVIER_ORDERS: readonly number[] = [1, 2, 3, 4, 5, 6];
